<script>
const BASE_URL = "";
export default {
  BASE_URL
}
</script>



// WEBPACK FOOTER //
// src/Global.vue